import React from "react";
import { User } from "firebase/auth";
import { AppContextType } from "../api/environment";

export interface AppContextWithAuth extends AppContextType {
  user?: User;
}

export const AppContext = React.createContext<AppContextWithAuth>({
  environment: '[unknown]'
});